import { render } from "./RankingSecond.vue?vue&type=template&id=af876852&scoped=true&ts=true&lang=pug"
import script from "./RankingSecond.vue?vue&type=script&lang=ts"
export * from "./RankingSecond.vue?vue&type=script&lang=ts"

import "./RankingSecond.vue?vue&type=style&index=0&id=af876852&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af876852"]])

export default __exports__